<div class="row">
    <div class="col-sm-12"> <h2 class="text-center" id="coreteamexecutive">Executive Team</h2></div>
    </div>
    <app-executive-kanagwa></app-executive-kanagwa>
    <app-executive-emma></app-executive-emma>
    <app-executive-marriette></app-executive-marriette>
    <div class="row">
    <div class="col-sm-12 coreteam-item"> <h2 class="text-center" id="coreteamadvisors">Advisory Board</h2></div>
    </div>
    <app-advisor-godwin></app-advisor-godwin>
    <app-advisor-kimanair></app-advisor-kimanair>
    <app-advisor-edgart></app-advisor-edgart>
    <app-country-level-syllabus></app-country-level-syllabus>

